import {
    switchType, redirect, animateCSS, sendToSpielSpass, getParams, checkForLength,
    stringSort, scrollListener, validateEmail, updateUserSession, updateUserSessionInEveryMinute
} from '../../_common/_functions';
import '@libraries/ErrorLogger';
import AdminLTE from '../../_plugins/adminlte/js/AdminLTE';
import Lobibox from '../../_plugins/lobibox/lobibox';
import SearchInput from './components/SearchInput';
import '../../_plugins/overlayScrollbars/js/jquery.overlayScrollbars';

import SelectPicker from './arbeitsblatt/helper/bootstrap-selectpicker';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';


(function() {
    var attachEvent = document.attachEvent, stylesCreated = false;

    if(!attachEvent) {
        window.requestFrame = (function() {
            var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) {
                return window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        })();
        window.cancelFrame = (function() {
            var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        })();
        window.resetTriggers = (element) => {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        window.checkTriggers = (element) => {
            return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
        };
        /* Detect CSS Animations support to detect element display/re-attach */
        var animation = false, animationstring = 'animation', keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        {
            var elm = document.createElement('fakeelement');
            if(elm.style.animationName !== undefined) {
                animation = true;
            }

            if(animation === false) {
                for(var i = 0; i < domPrefixes.length; i++) {
                    if(elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                        pfx = domPrefixes[i];
                        animationstring = pfx + 'Animation';
                        keyframeprefix = '-' + pfx.toLowerCase() + '-';
                        animationstartevent = startEvents[i];
                        animation = true;
                        break;
                    }
                }
            }
        }

        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }

    function createStyles() {
        if(!stylesCreated) {
            //opacity:0 works around a chrome bug
            // https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = document.head || document.getElementsByTagName('head')[0], style = document.createElement('style');

            style.type = 'text/css';
            if(style.styleSheet) {
                style.styleSheet.cssText = css;
            }
            else {
                style.appendChild(document.createTextNode(css));
            }

            head.appendChild(style);
            stylesCreated = true;
        }
    }

    window.addResizeListener = function(element, fn) {
        if(attachEvent) {
            element.attachEvent('onresize', fn);
        }
        else {
            if(!element.__resizeTriggers__) {
                if(getComputedStyle(element).position === 'static') {
                    element.style.position = 'relative';
                }
                createStyles();
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);

                /* Listen for a css animation to detect element display/re-attach */
                animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
                    if(e.animationName === animationName) {
                        resetTriggers(element);
                    }
                });
            }
            element.__resizeListeners__.push(fn);
        }
    };

    window.removeResizeListener = function(element, fn) {
        if(attachEvent) {
            element.detachEvent('onresize', fn);
        }
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if(!element.__resizeListeners__.length) {
                element.removeEventListener('scroll', scrollListener);
                element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
            }
        }
    };
})();

window.switchType = switchType;
window.redirect = redirect;
window.animateCSS = animateCSS;
window.sendToSpielSpass = sendToSpielSpass;
window.getParams = getParams;
window.checkForLength = checkForLength;
window.stringSort = stringSort;
window.scrollListener = scrollListener;
window.validateEmail = validateEmail;
window.updateUserSession = updateUserSession;
window.updateUserSessionInEveryMinute = updateUserSessionInEveryMinute;
window.profileImageFailed = async function profileImageFailed() {
  let { data } = await axios.post('/user/image/store', {
    noLoader: true
  });

  if(data.success) {
    let photo = data.avatar;
    document.querySelectorAll('img[data-profile-image]').forEach(node => {
      if(node && node.src) {
        node.src = photo;
      }
    });
    events.$emit('updateProfilePhoto', photo);
  }
}

window.fontList = [
    'Amaranth',
    'Noteworthy',
    'Montserrat',
    'HappyPhantom',
];
window.Swal = Swal.mixin({
    focusConfirm: true
});
window.SwalDelete = Swal.mixin({
    type: 'error',
    position: 'center',
    title: App.translate.swal.delete.title,
    text: App.translate.swal.delete.text,
    animation: false,
    customClass: {
        popup: 'animated tada'
    },
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#dd3333',
    confirmButtonText: App.translate.swal.yes,
    cancelButtonText: App.translate.swal.no,
    showCancelButton: true,
    showConfirmButton: true,
    allowOutsideClick: false,
    allowEnterKey: true,
    allowEscapeKey: true
});
window.SwalAreYouSure = Swal.mixin({
    type: 'question',
    position: 'center',
    title: App.translate.swal.areYouSure.title,
    text: App.translate.swal.areYouSure.text,
    animation: false,
    customClass: {
        popup: 'animated bounceIn'
    },
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#dd3333',
    confirmButtonText: App.translate.swal.yes,
    cancelButtonText: App.translate.swal.no,
    showCancelButton: true,
    showConfirmButton: true,
    allowOutsideClick: false,
    allowEnterKey: true,
    allowEscapeKey: true
});

new AdminLTE($);
new Lobibox($);
new SelectPicker($);
Vue.component('SearchInput', SearchInput);

var ModalEffects;
$(document).ready(function() {
    function classReg (className) {
        return new RegExp('(^|\\s+)' + className + '(\\s+|$)');
    }
    var hasClass, addClass, removeClass;
    if('classList' in document.documentElement) {
        hasClass = function(elem, c) {
            return elem.classList.contains(c);
        };
        addClass = function(elem, c) {
            elem.classList.add(c);
        };
        removeClass = function(elem, c) {
            elem.classList.remove(c);
        };
    }
    else {
        hasClass = function(elem, c) {
            return classReg(c).test(elem.className);
        };
        addClass = function(elem, c) {
            if(!hasClass(elem, c)) {
                elem.className = elem.className + ' ' + c;
            }
        };
        removeClass = function(elem, c) {
            elem.className = elem.className.replace(classReg(c), ' ');
        };
    }
    function toggleClass (elem, c) {
        var fn = hasClass(elem, c) ? removeClass : addClass;
        fn(elem, c);
    }
    var classie = {
        // full names
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        toggleClass: toggleClass,
        // short names
        has: hasClass,
        add: addClass,
        remove: removeClass,
        toggle: toggleClass
    };
    ModalEffects = (function() {
        var ModalEffects = {};
        ModalEffects.init = function(el) {
            var rnd = [1,2,3,4,5,6,8,9,10,11,13,14,15,17,18,19];
            var overlay = document.querySelector('.md-overlay');

            var modal = el, close = modal.querySelector('.md-close');
            classie.add(modal, 'md-effect-' + GetRandom(rnd));
            classie.add(modal, 'md-show');

            function removeModal (hasPerspective) {
                classie.remove(modal, 'md-show');
                classie.remove(modal, 'md-effect-1');
                classie.remove(modal, 'md-effect-2');
                classie.remove(modal, 'md-effect-3');
                classie.remove(modal, 'md-effect-4');
                classie.remove(modal, 'md-effect-5');
                classie.remove(modal, 'md-effect-6');
                classie.remove(modal, 'md-effect-7');
                classie.remove(modal, 'md-effect-8');
                classie.remove(modal, 'md-effect-9');
                classie.remove(modal, 'md-effect-10');
                classie.remove(modal, 'md-effect-11');
                classie.remove(modal, 'md-effect-12');
                classie.remove(modal, 'md-effect-13');
                classie.remove(modal, 'md-effect-14');
                classie.remove(modal, 'md-effect-15');
                classie.remove(modal, 'md-effect-16');
                classie.remove(modal, 'md-effect-17');
                classie.remove(modal, 'md-effect-18');
                classie.remove(modal, 'md-effect-19');
                classie.add(modal, 'md-effect-'+GetRandom(rnd));
                if(hasPerspective) {
                    classie.remove(document.documentElement, 'md-perspective');
                }
            }

            function removeModalHandler () {
                removeModal(classie.has(el, 'md-setperspective'));
            }

            el.addEventListener('click', function(ev) {
                classie.add(modal, 'md-show');
                overlay.removeEventListener('click', removeModalHandler);
                overlay.addEventListener('click', removeModalHandler);

                if(classie.has(el, 'md-setperspective')) {
                    setTimeout(function() {
                        classie.add(document.documentElement, 'md-perspective');
                    }, 25);
                }
            });

            close.addEventListener('click', function(ev) {
                ev.stopPropagation();
                removeModalHandler();
            });
        };
        return ModalEffects;
    })();

    $('.navigation-buttons').on('click', function() {
        $(this).unbind();
        $('body').addClass('loading');
    });

    window.ModalEffects = ModalEffects;

    if(window.OverlayScrollbars) {
        let options = {
            className: 'os-theme-dark',
            sizeAutoCapable: true,
            scrollbars: {
                autoHide: 'never',
                clickScrolling: true
            },
            paddingAbsolute:true
        };
        //window.scroller = OverlayScrollbars($('body'), options);
        window.scroller = OverlayScrollbars($('.main-sidebar .sidebar'), options);

        var $activeLink = $('.menu-open');
        if($activeLink.length && window.scroller) {
            window.scroller.scroll({
                y: $activeLink.eq(0).offset().top - $('.brand-link').outerHeight()
            }, 1000);
        }
    }

    window.addEventListener('beforeunload', () => {
        if (typeof socket !== 'undefined') {
            socket.emit('setPassive');
        }
    });
});

import './core/socket';
